import { render, staticRenderFns } from "./DeltaFit.vue?vue&type=template&id=8458fa86&"
import script from "./DeltaFit.vue?vue&type=script&lang=js&"
export * from "./DeltaFit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports